import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { CustomSVG } from './';

interface Props {
  active: boolean;
  provider: any;
  className?: string;
  size?: number;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: 12,
    verticalAlign: 'middle',
  },
  inactive: {
    color: theme.palette.action.disabled,
  },
  twitter: {
    color: theme.custom.networks.twitter,
  },
  linkedin: {
    color: theme.custom.networks.linkedin,
  },
  facebook: {
    color: theme.custom.networks.facebook,
  },
  msteams: {
    color: theme.custom.networks.msTeams,
  },
}));

const SocialAccountIcon: FC<Props> = ({ className, active, provider, size }) => {
  const classes = useStyles();

  return (
    <CustomSVG
      className={classNames(className || classes.root, {
        [classes[provider]]: active,
        [classes.inactive]: !active,
      })}
      name={provider}
      size={size}
    />
  );
};

SocialAccountIcon.defaultProps = {
  size: 28,
};

export default SocialAccountIcon;
